'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GRID_RESIZE = exports.FONT_SIZE_MULTIPLIER = exports.GRID_SIZE_LIST = exports.GRID = undefined;

var _lodash = require('lodash');

var GRID = exports.GRID = {
    MOBILE: { size: 10, breakpoint: 0, name: 'mobile' },
    SMALL: { size: 8, breakpoint: 600, name: 'small' },
    MEDIUM: { size: 10, breakpoint: 1600, name: 'regular' }
};

var GRID_SIZE_LIST = exports.GRID_SIZE_LIST = (0, _lodash.values)(GRID);

var DEFAULT_FONT_SIZE = 16;
var FONT_SIZE_MULTIPLIER = exports.FONT_SIZE_MULTIPLIER = DEFAULT_FONT_SIZE / GRID.MEDIUM.size;

var GRID_RESIZE = exports.GRID_RESIZE = 'GRID_RESIZE';


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/gridConstants.js
// module id = 205
// module chunks = 0